"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wordTableScriptDefinition = exports.scriptDefinition = void 0;
const firestore_1 = require("comodel/firestore");
const project_1 = require("./project");
exports.scriptDefinition = (0, firestore_1.defineCollection)({
    collectionName: "script",
    idKey: "segmentScriptId",
    parent: project_1.projectDefinition,
    constraints: ["projectId", "segmentId", "scriptId"],
    queryDefs: {
        list: ({ projectId, segmentId, condition, }) => {
            if (!segmentId)
                return undefined;
            return {
                constraint: { projectId },
                queryParams: { filter: { segmentId } },
                filterParams: condition,
            };
        },
    },
    defaultValue: {},
    onAccess: (o) => o.scriptId
        ? Object.assign(Object.assign({}, o), { segmentScriptId: `${o.segmentId}:${o.scriptId}` }) : o,
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
exports.wordTableScriptDefinition = (0, firestore_1.defineCollection)({
    collectionName: "script",
    idKey: "segmentScriptId",
    parent: project_1.projectDefinition,
    constraints: ["projectId", "segmentId", "scriptId"],
    queryDefs: {
        list: ({ projectId, condition, }) => {
            return {
                constraint: { projectId },
                queryParams: {
                    filter: { shouldIncludedIntoSegmentLevelWordTable: true },
                },
                filterParams: condition,
            };
        },
    },
    defaultValue: {},
    onAccess: (o) => o.scriptId
        ? Object.assign(Object.assign({}, o), { segmentScriptId: `${o.segmentId}:${o.scriptId}` }) : o,
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
